/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import {FinderCTACardType} from "../../../data/finders.model";
import Block from "../../atoms/layout/Block";



export class GirdListCtaCard extends React.Component {

    static propTypes = {
        ...FinderCTACardType
    };

    render() {
        const { ctaTitle, ctaText, ctaBtnLabel, ctaBtnLink} = this.props;

        if (!ctaTitle && !ctaText) {
            return null;
        }

        return <Block className="finder-card col-xs-12 col-sm-6 col-md-4 col-lg-3 p-flex p-flex-column">
            <div className="thumbnail thumbnail--bare" data-mh="item">
                <div className="caption" data-mh="product-item">
                    <h5 className="p-margin-top">{ctaTitle}</h5>
                    <p>{ctaText}</p>
                </div>
                {ctaBtnLabel &&<div className="caption">
                    <p>
                        <a href={ctaBtnLink} className="btn-secondary text-wrap-normal">
                            {ctaBtnLabel}
                        </a>
                    </p>
                </div>}
            </div>
        </Block>
    }

}
